const status = {
  lookingForJob: true,
};

const ResumeData = {
  experience: [
    {
      title: 'Director of Software Development',
      dateStart: new Date(2022, 8, 6),
      dateEnd: null,
      company: 'Vivacity',
      location: 'Remote',
      noPrint: false,
      edBool: false,
      devBool: true,
      details: [
        'Spearheaded the creation and leadership of a dynamic team of 30+ software professionals, including dev, QA, design, and product, fostering a collaborative environment conducive to innovation and productivity.',
        'Oversaw multiple software development teams and orchestrated the end-to-end delivery of cutting-edge Node.js and React projects in TypeScript, demonstrating expertise in architecting scalable solutions from inception to deployment.',
        'Elevated efficiency and reliability by serving as the Database Administrator (DBA) for various Postgres databases, ensuring optimal performance and integrity across various environments.',
        'Built AI-enabled development processes and agentic workflows across engineering operations, increasing software development productivity by 25% while reducing manual effort.',
        'Leveraged industry-leading tools such as Launch Darkly and Datadog to drive continuous improvement and optimization efforts, enabling real-time monitoring and actionable insights for enhanced decision-making.',
        'Led the technical workstream for SOC 2 compliance, authoring engineering policies, secure software standards, and SDLC controls that strengthened audit readiness across the organization.',
        'Owned software budget planning and company-level technical strategy, aligning staffing, roadmap priorities, and platform investments with executive business goals.',
        'Spearheaded the design and launch of a comprehensive internship program in partnership with multiple universities, establishing six distinct internship tracks and building a sustainable talent pipeline that accelerated team growth and workforce readiness.',
        'Evaluated and operationalized AI tools for development workflows, enabling teams to adopt agentic delivery patterns that improved speed, consistency, and output quality.',
        // 'Worked on an AI investigation team to find and produce AI tools beneficial for our company employees and customers.',
        // 'Developed comprehensive AI policies encompassing ethical and legal considerations, enhancing the integration of AI into the company',
        // 'Assisted in the development of data governance policies and procedures, ensuring robust and secure applications for our users.',
        // 'Coached development leads on managerial skills including team building, mentoring, resource management, etc., fostering leadership capabilities.',
        'Continuously optimized development processes by implementing CI/CD pipelines in GitHub, ensuring rapid and reliable deployment of code while maintaining rigorous quality standards.',
      ],
    },
    {
      title: 'Computer Science Professor',
      dateStart: new Date(2019, 7, 1),
      dateEnd: new Date(2024, 11, 18),
      company: 'BYU-Idaho',
      location: 'Rexburg, ID',
      noPrint: false,
      edBool: true,
      devBool: false,
      details: [
        'Created courses focused on the MERN stack (MongoDB, Express.js, React, Node.js)',
        'Taught programming classes in Python, Java, C++, native Android development, and  web engineering classes utilizing HTML, CSS, JavaScript, PHP, Node.js, Postgres, and MongoDB',
        'Mentored thousands of students in professional development and career research',
        'Actively participated in numerous citizenship opportunities on campus, including serving on program committees for the Web Design and Development and Computer Science degrees, fostering interdisciplinary collaboration and curriculum enhancement',
        'Developed comprehensive AI policies encompassing ethical and legal considerations, enhancing the integration of AI into academic frameworks',
        'Authored a productivity guide to empower students and faculty to harness the capabilities of AI effectively in their academic and professional endeavors',
        'Presented insights on AI applications and ethics at multiple university events, contributing to the ongoing discourse on AI in academia',
      ],
    },
    {
      title: 'Online Instructor',
      dateStart: new Date(2018, 8, 1),
      dateEnd: new Date(2024, 11, 18),
      company: 'BYU-Idaho',
      location: 'Remote',
      noPrint: false,
      edBool: true,
      devBool: false,
      details: [
        'Taught programming classes in HTML, CSS, JavaScript, Java, and Android Development',
        `Mentored over 30 online instructors and assisted with many classes`,
        'Assisted in the planning, designing, and maintenance of courses taken by software engineering students worldwide',
      ],
    },
    {
      title: 'Application Developer',
      dateStart: new Date(2022, 3, 25),
      dateEnd: new Date(2022, 8, 6),
      company: '1-800 Flowers',
      location: 'Remote',
      noPrint: false,
      edBool: false,
      devBool: true,
      details: [
        'Positioned as development lead, managed repositories, and performed roughly 10 code reviews per week',
        'Developed and supported web applications built with React, Redux, TypeScript, and GraphQL',
        'Created full-stack applications with REST APIs in Node.js/TypeScript on the backend and React on the frontend',
        '^^Utilized MongoDB and Auth0 to manage over 10,000,000 users',
        '^^Monitored production environment health status using Datadog',
      ],
    },
    {
      title: 'Instructional Specialist',
      dateStart: new Date(2021, 8, 1),
      dateEnd: new Date(2022, 3, 1),
      company: 'Trilogy Education',
      location: 'Remote',
      noPrint: true,
      edBool: true,
      devBool: false,
      details: [
        'Specialized in the instruction of full-stack web development courses',
        'Assisted students in learning the MERN stack (MongoDB, Express.js, React.js, & Node.js)',
      ],
    },
    {
      title: 'Web Development Expert',
      dateStart: new Date(2021, 3, 1),
      dateEnd: new Date(2022, 3, 1),
      company: 'Digital Workshop Center',
      location: 'Remote',
      noPrint: false,
      edBool: true,
      devBool: false,
      details: [
        'Designed curriculum, lessons, and assignments for courses that ended up being used by the entire company',
        'Instructed classes in web design and development, web tools, HTML and CSS, entry-level JavaScript, advanced JavaScript, and React',
        'Mentored students and assisted them in professional development pursuits',
      ],
    },
    {
      title: 'Dev Lead and Internship Coordinator',
      dateStart: new Date(2020, 3, 1),
      dateEnd: new Date(2022, 3, 1),
      company: 'Allucent',
      location: 'Remote',
      noPrint: false,
      edBool: false,
      devBool: true,
      details: [
        'Launched a state-of-the-art SaaS product for the construction industry using VueJS and NoSQL database (Firebase)',
        'Employed Node.js to build scalable RESTful APIs',
        '^^Led the process of interviewing, hiring, training, and managing over 10 software engineering interns',
        '^^Developed advanced reporting systems, visual graphics, and graphical metrics all in JavaScript',
      ],
    },
    {
      title: 'Contract Full Stack Developer',
      dateStart: new Date(2020, 0, 1),
      dateEnd: new Date(2020, 6, 1),
      company: 'Feichtner Data Group',
      location: 'Remote',
      noPrint: false,
      edBool: false,
      devBool: true,
      details: [
        'Created Python script to access interstate cameras and sensors, then save data to MongoDB',
        'Pioneered full-stack web application from whiteboard to production in Node.js, Express, and EJS that displayed real-time data from MongoDB to law enforcement officials',
        '^^Used Node.js to connect to and communicate with a PostgreSQL database',
      ],
    },
    {
      title: 'Software Developer',
      dateStart: new Date(2016, 3, 1),
      dateEnd: new Date(2019, 4, 1),
      company: 'General Motors',
      location: 'Austin, TX',
      noPrint: false,
      edBool: false,
      devBool: true,
      details: [
        'Positioned as Dev Lead, managing several projects over an international team of 10+ engineers',
        'Published multiple complex web applications utilizing Angular, AngularJS, HTML5, CSS3, REST, and Java Spring Boot',
        '^^Wrote RESTful APIs with Java Spring Boot to communicate with Oracle SQL Database',
        '^^Constructed innovative mobile applications for both Android and iOS in modern technologies such as Angular, Cordova, PhoneGap, and Ionic',
        '^^Wrote software documentation that increased productivity for various teams around the company',
      ],
    },
    {
      title: 'Online English Teacher',
      dateStart: new Date(2016, 11, 1),
      dateEnd: new Date(2018, 7, 1),
      company: 'VIP Kid',
      location: 'Remote',
      noPrint: true,
      edBool: true,
      devBool: false,
      details: ['Taught English as a second language to children in China'],
    },
    {
      title: 'Software Development Engineer',
      dateStart: new Date(2015, 3, 1),
      dateEnd: new Date(2016, 3, 1),
      company: 'The Church of Jesus Christ of Latter-day Saints',
      location: 'Riverton, UT',
      noPrint: false,
      edBool: false,
      devBool: true,
      details: [
        'Produced advanced client/server web applications using ASP.NET, AngularJS, C#, & Oracle SQL Database',
        'Implemented advanced CSS and JavaScript techniques to provide beautifully responsive and performant applications',
        '^^Collaborated and worked with small teams on complex, interactive projects implementing agile methodologies of project development and management',
      ],
    },
    {
      title: 'Web Developer and Strategist',
      dateStart: new Date(2014, 8, 1),
      dateEnd: new Date(2015, 3, 1),
      company: 'BYU-Idaho',
      location: 'Rexburg, ID',
      noPrint: false,
      edBool: false,
      devBool: true,
      details: [
        'Planned and implemented various university websites using HTML5, CSS3, and JavaScript that helped educate students',
        '^^Worked with CSS and JavaScript libraries such as Bootstrap',
      ],
    },
  ],
  education: [
    {
      title: "Master's in Computer Information Systems, Security",
      dateStart: null,
      dateEnd: new Date(2019, 3, 1),
      company: 'Boston University',
      location: 'Boston, MA',
      noPrint: false,
      edBool: false,
      devBool: false,
      details: [
        'Business Data Communication and Networks',
        'Database Design and Implementation for Business (SQL and NoSQL)',
        'Information Systems Analysis and Design',
        'IT Strategy and Management',
        'Information Structures with Python',
        'Introduction to Probability and Statistics',
        'Enterprise Cybersecurity Management',
        'Enterprise Cyber Security',
        'Database Security',
        'Network Security',
      ],
    },
    {
      title: 'Bachelor of Science in Information Technology',
      dateStart: null,
      dateEnd: new Date(2016, 3, 1),
      company: 'Brigham Young University - Idaho',
      location: 'Rexburg, ID',
      noPrint: false,
      edBool: false,
      devBool: false,
      details: [
        'Object Oriented Programming',
        'Database Design & Development',
        'System Analysis and Design',
        'Database Administration',
        'Systems Security',
        'Mobile Application Development',
        'Web Frontend Development',
        'Web Backend Development',
        'Networking and Network Design',
        'Operating Systems',
      ],
    },
    {
      title: "Associate's Degree",
      dateStart: null,
      dateEnd: new Date(2013, 11, 1),
      company: 'Spokane Community College',
      location: 'Spokane, WA',
      noPrint: false,
      edBool: false,
      devBool: false,
      details: [],
    },
  ],
  skills: [
    { title: 'HTML', dateStart: new Date(2014, 4, 16), dateEnd: null },
    { title: 'CSS', dateStart: new Date(2014, 4, 16), dateEnd: null },
    { title: 'JavaScript', dateStart: new Date(2014, 3, 1), dateEnd: null },
    { title: 'React', dateStart: new Date(2020, 5, 16), dateEnd: null },
    { title: 'Next.js', dateStart: new Date(2021, 3, 16), dateEnd: null },
    { title: 'Vue.js', dateStart: new Date(2020, 3, 16), dateEnd: null },
    { title: 'TypeScript', dateStart: new Date(2020, 5, 16), dateEnd: null },
    { title: 'Node.js', dateStart: new Date(2018, 7, 16), dateEnd: null },
    {
      title: 'Java',
      dateStart: new Date(2020, 7, 16),
      dateEnd: null,
    },
    { title: 'Python', dateStart: new Date(2019, 5, 16), dateEnd: null },
    { title: 'MongoDB', dateStart: new Date(2019, 7, 16), dateEnd: null },
    {
      title: 'PostgreSQL',
      dateStart: new Date(2019, 7, 16),
      dateEnd: null,
    },
    {
      title: 'Architecture',
      dateStart: new Date(2020, 0, 1),
      dateEnd: null,
    },
    {
      title: 'REST APIs',
      dateStart: new Date(2015, 3, 1),
      dateEnd: null,
    },
    {
      title: 'Express.js',
      dateStart: new Date(2019, 7, 1),
      dateEnd: null,
    },
    {
      title: 'GraphQL',
      dateStart: new Date(2022, 3, 25),
      dateEnd: new Date(2022, 8, 6),
    },
    {
      title: 'CI/CD',
      dateStart: new Date(2022, 8, 6),
      dateEnd: null,
    },
    {
      title: 'GitHub Actions',
      dateStart: new Date(2022, 8, 6),
      dateEnd: null,
    },
    {
      title: 'LaunchDarkly',
      dateStart: new Date(2022, 8, 6),
      dateEnd: null,
    },
    {
      title: 'Datadog',
      dateStart: new Date(2022, 8, 6),
      dateEnd: null,
    },
    {
      title: 'GCP',
      dateStart: new Date(2022, 8, 6),
      dateEnd: null,
    },
    {
      title: 'Auth0',
      dateStart: new Date(2022, 3, 25),
      dateEnd: new Date(2022, 8, 6),
    },
  ],
  softSkills: [
    {
      title: 'Cross-Functional Leadership',
      description:
        'Leads engineering, QA, design, and product teams toward shared goals, clear accountability, and strong execution',
    },
    {
      title: 'Strategic Planning',
      description:
        'Aligns technical direction with business priorities, long-term roadmaps, and organizational goals',
    },
    {
      title: 'Mentorship',
      description:
        'Develops engineers and emerging leaders through consistent guidance, feedback, and growth opportunities',
    },
    {
      title: 'Coaching',
      description:
        'Supports individual contributors and leads with practical coaching that improves performance and confidence',
    },
    {
      title: 'Hiring & Team Building',
      description:
        'Builds healthy, effective teams through hiring, role design, onboarding, and talent development',
    },
    {
      title: 'Stakeholder Management',
      description:
        'Builds alignment with executives, product owners, and partners through clear expectations and dependable follow-through',
    },
    {
      title: 'Executive Communication',
      description:
        'Communicates roadmaps, risks, priorities, and results clearly to technical and non-technical audiences',
    },
    {
      title: 'Financial Stewardship',
      description:
        'Manages software budgets, staffing tradeoffs, and technology investments with a focus on business value and responsible growth',
    },
    {
      title: 'Risk Management',
      description:
        'Identifies and mitigates delivery, security, and operational risks before they become costly business problems',
    },
    {
      title: 'Technology Vision',
      description:
        'Sets long-term technical direction that supports scale, resilience, innovation, and company strategy',
    },
    {
      title: 'Process Improvement',
      description:
        'Improves team effectiveness by refining delivery systems, workflows, and engineering practices',
    },
    {
      title: 'Change Management',
      description:
        'Guides teams through new tools, structures, and ways of working with clarity and stability',
    },
    {
      title: 'Decision-Making',
      description:
        'Makes sound, timely decisions in ambiguous situations while balancing speed, quality, and business impact',
    },
    {
      title: 'Delivery Management',
      description:
        'Keeps complex initiatives moving across teams with clear prioritization, planning, and execution',
    },
    {
      title: 'Organizational Leadership',
      description:
        'Creates structure, accountability, and a strong team culture that scales with the business',
    },
  ],
};

export { ResumeData, status };
